import styled from 'styled-components';
import { Tag, IconButton, InputNumber } from 'rsuite';

export const FileTag = styled(Tag)`
  margin-top: 8px;
  margin-right: 20px;
`;

export const ImageWrapper = styled.div`
  border-radius: 5px;
  position: relative;
  display: inline-block;
  border: 1px solid;
  border-color: #adadad;
  width: 300px;
  margin-top: 10px;
  padding: 3px;
`;

export const RemoveImageIcon = styled(IconButton)`
  top: -10px;
  right: -12px;
  position: absolute !important;
`;

export const QuantityInput = styled(InputNumber)`
  width: 70px;
  display: inline-flex;
  vertical-align: middle;
  margin-right: 10px;
`;
